<template>
  <div>
    <slot v-bind:open="open" />

    <modal :show="show"  @closeModal="close">
        <assign-modal :date="note.delivery_date" @assign="assignToTeam"></assign-modal>
    </modal>
  </div>
</template>

<script>
import AssignModal from "../MasterList/AssignModal.vue";
import Modal from "../../../Shared/Modal.vue";

export default {
  name: 'AssignTeamModal',
  components: {Modal, AssignModal},

  props: {
    note: Object,
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      show: false,
      form: this.$inertia.form({
        team_id: null,
        delivery_date: this.note.delivery_date || null,
        items: this.items || []
      })
    }
  },

  methods: {
    open() {
      this.show = true
    },
    close() {
      this.$emit('closed')
      this.show = false
    },
    assignToTeam(team) {
      this.form.team_id = team.team_id
      this.form.delivery_date = team.delivery_date
      this.form.items = this.items
      this.form.post(this.route('delivery-notes.assign-team', this.note.id), {
        onSuccess: () => this.close()
      })
    },
  }
}
</script>
